import { Box, Typography, Grid } from '@mui/material';

interface FormSectionProps {
  title: string;
  children: React.ReactNode;
  columns?: number; // number of columns inside the section
}

export const FormSection: React.FC<FormSectionProps> = ({ title, children, columns = 1 }) => {
  const safeColumns = Math.max(1, Math.min(columns, 5));
  const childArray = Array.isArray(children) ? children : [children];

  return (
    <Box sx={{ marginBottom: 1, marginTop: 1 }}>
      <Box sx={{ borderBottom: '1px solid #55575C', marginBottom: 3 }}>
        <Typography
          sx={{
            fontSize: '16px !important',
            fontFamily: 'Helvetica Neue, sans-serif !important',
            fontWeight: '600 !important',
            color: '#55575C !important',
          }}
        >
          {title}
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {childArray.map((child, idx) => (
          <Grid size={12 / safeColumns} key={idx} maxWidth={'50vw'}>
            {child}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
